<!--
 * @Author: Ximen
 * @Date: 2021-03-23 19:40:08
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-06 17:22:33
-->
<template>
  <a-modal
  v-model:visible="visible" :footer="null" width="420px" @cancel="close()">
    <div v-if="!gradePayInfo.codeUrl">
      <p class="title">选择支付方式</p>
      <p class="trc">支付金额</p>
      <p class="price">￥{{payInfo.value}}</p>
      <p class="trc">支付方式</p>
      <div class="payBox">
        <div :class="checkedModal==0?'checked':''"
        class="payBorder" @click="checkPayMode(0)">
          <img v-if="checkedModal==0" class="check" src="@/assets/boder3.png" alt="">
          <img class="pic" src="@/assets/alipay.png" alt="alipay" />
        </div>
        <div :class="checkedModal==1?'checked':''"
        class="payBorder1" @click="checkPayMode(1)">
          <img v-if="checkedModal==1" class="check" src="@/assets/boder3.png" alt="">
          <img class="pic" src="@/assets/wechatpay.png" alt="wechatpay" />
        </div>
      </div>
      <a-button type="primary" class="accept-btn" @click="goPay()">去支付</a-button>
    </div>
    <div v-show="gradePayInfo.codeUrl">
      <p class="title">立即支付</p>
      <div id="qrcode" ></div>
    </div>
    </a-modal>
</template>

<script lang='ts'>
import { defineComponent } from 'vue';
import commonApi from '@/api/common';
import { qrcanvas } from 'qrcanvas';

export default defineComponent({
  name: 'PayModal',
  data() {
    return {
      visible: false,
      checkedModal: 0,
      timer: 0,
      gradePayInfo: {
        codeUrl: '',
        payOrderNo: '',
        sn: '',
      },
      payStyle: {
        thirdPartyPayGroup: [
          {
            paymentId: '',
          },
        ],
      },
    };
  },
  props: ['payInfo'],
  components: {
  },
  mounted() {
    this.getPayFun();
  },
  methods: {
    checkPayMode(num: number) {
      console.log(num);
      this.checkedModal = num;
    },
    showModal() {
      this.visible = true;
    },
    getPayFun() {
      interface Data{
        data: any;
        success: boolean;
        message: string;
      }
      commonApi.getPayChannels({}).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          this.payStyle = data;
        } else {
          // this.error(message);
          console.log(message);
        }
      });
    },
    close() {
      this.gradePayInfo.codeUrl = '';
      clearInterval(this.timer);
    },
    goPay() {
      interface Data{
        data: {
          codeUrl: '';
          payOrderNo: '';
          sn: '';
        };
        success: boolean;
        message: string;
      }
      commonApi.upgradePay({
        versionType: this.payInfo.key ? this.payInfo.key : this.payInfo.versionType,
        paymentId: this.payStyle.thirdPartyPayGroup[this.checkedModal].paymentId,
        // amount: this.payInfo.value,
        amount: 0.01,
        rechargeNo: this.payInfo.rechargeNo ? this.payInfo.rechargeNo : '',
      }).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          this.gradePayInfo = data;
          const canvas = qrcanvas({
            data: this.gradePayInfo.codeUrl,
            size: 372,
          });
          const qrUrl: any|null = document.getElementById('qrcode');
          qrUrl.innerHTML = '';
          qrUrl.appendChild(canvas);
          this.timer = setInterval(() => {
            this.queryPayStatus();
          }, 1000);
        } else {
          // this.error(message);
          console.log(message);
        }
      });
    },
    queryPayStatus() {
    interface Data{
        data: number;
        success: boolean;
        message: string;
      }
    const params = {
      payOrderNo: this.gradePayInfo.payOrderNo,
      paymentId: this.payStyle.thirdPartyPayGroup[this.checkedModal].paymentId,
      type: 4,
    };
    commonApi.queryPayStatus(params).then(async ({ data, success, message }: Data) => {
      if (success) {
        console.log(data);
        if (data === 1) {
          // this.success('');
          this.close();
          this.$router.push('/payResult');
        }
      } else {
        console.log(message);
      }
    });
    },
  },
});
</script>
<style lang="stylus" scoped>
  .title
    font-size 24px
    color #073D7D
    text-align center
    margin-bottom 26px
  .trc
    font-size 16px
    color #333
    text-align center
    margin-bottom 0
  .price
    font-size 50px
    color #FF0018
    text-align center
    margin 0
    line-height 70px
  .payBox
    margin-top 20px
    display flex
    flex-direction row
    justify-content space-between
    .payBorder
      border 1px solid #d5d5d5
      width 170px
      padding 25px 33px 23px
      border-radius 8px
      position relative
      .pic
        width 100%
        height 38px
      .check
        position absolute
        right 0
        top 0
        height 36px
        width 36px
    .payBorder1
      border 1px solid #d5d5d5
      width 170px
      padding 26px 17px 21px
      border-radius 8px
      position relative
      .check
        position absolute
        right 0
        top 0
        height 36px
        width 36px
      .pic
        width 100%
        height 38px
    .checked
      border 2px solid #3281DD
  .accept-btn
    width 100%
    height 50px
    font-size 16px
    margin-top 30px
    border-radius 5px
    background #3281dd
    color #fff
    border none
</style>
